import { IconBase, IconComponent } from './BaseIcon';

export const FlagReport: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M24.07 10.22 29.7 0H3.43C2.8 0 2.28.5 2.28 1.14v29.72a1.14 1.14 0 1 0 2.3 0V19.5H29.7Zm-19.5 6.92V2.28h21.25l-4.4 8 4.21 6.86Z" />
  </IconBase>
);
